module.exports = __webpack_public_path__ + "img/login-bg.e524fea5.png";